/**
 * @prettier
 */

/**
 * Web Service handler to retrieve and represent a list of services
 * at a location or Merchant
 *
 * @class ServiceTransactionStartWS
 */
var ServiceTransactionStartWS = function (parent) {
  var self = this; // Convenience reference so the context of 'this' becomes clearer

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self.method = ko.observable("POST");
  self.name = "ServiceTransactionStartWS"; // Convenience name for debugging

  /**
   * API Endpoint
   *
   * @method serviceURL
   * @return {String}
   */
  self.serviceURL = ko.computed(
    function () {
      return "/qless/api/v1/employee/serviceTransaction/start";
    },
    self,
    { deferEvaluation: true }
  );

  /**
   * Processes the return from the API service
   *
   * @method processData
   * @param {XMLDocument} xmlData
   * @return none
   */
  self.processData = function (xmlData) {
    AbstractWS.prototype.processData.call(self, xmlData);

    self.parent.appointmentPopupHide();

  };

  return self;
};

ServiceTransactionStartWS.prototype = Object.create(AbstractWS.prototype);

/**
 * @tyepdef {Object} ServiceTransactionStartParams
 * @property {string|number} appointmentId
 * @property {string|number} locationId
 * @property {string|number} queueId
 * @property {string|number} transactionTypeId
 * @property {string|number} phone
 * @property {string} firstName
 * @prop {string} notes
 * @prop {string} lastName
 * @prop {number} partySize
 */

/**
 *
 * @param {ServiceTransactionStartParams} requestParams
 */
ServiceTransactionStartWS.prototype.startServiceTransaction = function (requestParams, onSuccess, onError) {
  this.clearParams();

  this.addParam("appointmentId", requestParams.appointmentId);
  this.addParam("locationId", requestParams.locationId);
  this.addParam("queueId", requestParams.queueId);
  this.addParam("transactionType", requestParams.transactionTypeId);
  this.addParam("phone", requestParams.phone);
  this.addParam("firstName", requestParams.firstName);

  var optionalParameters = ["lastName", "notes", "partySize"];
  optionalParameters.forEach(
    function (value) {
      if (requestParams[value]) {
        this.addParam(value, requestParams[value]);
      }
    }.bind(this)
  );

  if (onError instanceof Function) {
    this.errorHandler = onError;
  } else {
    this.errorHandler = function () {};
  }

  this.doRequest(onSuccess);
};

if (typeof exports !== "undefined") {
  exports.ServiceTransactionStartWS = ServiceTransactionStartWS;
}
